// Run before Angular starts so URLs sent to telemetry never contain the secret.
export function captureHistoryImport(): void {
  const fragment = new URLSearchParams(location.hash.slice(1));
  const token = fragment.get('history-import');
  if (!token) return;
  const shipUuid = location.pathname.split('/').filter(Boolean)[0];
  history.replaceState(history.state, '', location.pathname + location.search);
  if (shipUuid) sessionStorage.setItem(historyImportKey(shipUuid), token);
}

export const historyImportKey = (shipUuid: string) => `history-import:${shipUuid.toLowerCase()}`;
